<template>
  <autocomplete
    :debounce-time="500"
    :default-value="defaultValue"
    :search="onSearch"
    :get-result-value="getResultValue"
    @submit="onSubmit"
  >
    <template
      #default="{
        rootProps,
        inputProps,
        inputListeners,
        resultListProps,
        resultListListeners,
        results,
        resultProps
        }"
    >
      <div v-bind="rootProps">
        <fg-input
          v-bind="inputProps"
          :class="[
            {'autocomplete-input-focused': focused},
            {'autocomplete-input-no-results': noResults}
          ]"
          :addon-left-icon="leftIcon"
          placeholder="Enter departure airport"
          v-on="inputListeners"
          @blur="onBlur"
          @focus="onFocus"/>
        <ul
          v-if="noResults"
          class="autocomplete-result-list"
          style="position: absolute; z-index: 1; width: 100%; top: 100%;"
        >
          <li class="autocomplete-result">
            No results found
          </li>
        </ul>
        <ul 
          v-bind="resultListProps" 
          v-on="resultListListeners">
          <li
            v-for="(result, index) in results"
            :key="resultProps[index].id"
            v-bind="resultProps[index]"
          >
            {{ result.name }}
          </li>
        </ul>
      </div>
    </template>
  </autocomplete>
</template>

<script>
  import Autocomplete from '@trevoreyre/autocomplete-vue';
  import '@trevoreyre/autocomplete-vue/dist/style.css';
  import { FormGroupInput } from '@/components';
  import axios from 'axios';

  export default {
    components: {
      Autocomplete,
      [FormGroupInput.name]: FormGroupInput
    },
    props: {
      leftIcon: {
        type: String
      },
      defaultValue: {
        type: String,
        default: ''
      }
    }, 
    data: function () {
      return {
        focused: false,
        term: '',
        results: [],
      }
    },
    computed: {
      noResults: function () {
        return this.term && this.results.length === 0
      },
    },
    methods: {
      onSearch: function (input) {
        this.term = input;  
        return new Promise((resolve) => {
          if (input.length < 2) {
            return resolve([])
          }

          axios.get(`airport/search?term=${input}`).then((res) => {
            this.results = res.data;
            resolve(res.data);
          })
        })
      },
      getResultValue: function (result) {
        return result.name
      },
      onSubmit: function (result) {
        this.$emit('submit', result)
      },
      onFocus: function () {
        this.$emit('focus');
        this.focused = true;
      },
      onBlur: function () {
        this.focused = false;
      }
    } 

  }
</script>

<style lang="scss" scoped>
  .autocomplete {
    ::v-deep .input-group-text,
    ::v-deep input {
      background-color: white;
      z-index: 2;
    }
    .autocomplete-result-list {
      max-height: 120px;
      color: #2c2c2c;
      border-radius: 0.25rem;
      padding-top: 4px;
      padding-bottom: 4px;
      box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);

      .autocomplete-result {
        background-image: none;
        padding: 10px 18px;

        &:hover {
          background-color: #345AAD;
          color: white;
        }
      }
    }
    .autocomplete-input-no-results:not(.autocomplete-input-focused) ~ .autocomplete-result-list {
      display: none;
    }
  }
</style>